import MySection from './components/MySection.svelte';
import BeforeAfter from './components/BeforeAfter.svelte';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';



const app = new MySection({
  target: document.getElementById('svelte-section'),
});

export default app;

new BeforeAfter({
  target: document.getElementById('before-after'),
});



// Init Swiper
window.addEventListener("load", () => {
  new Swiper(".clients-slider", {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    spaceBetween: 40,
    freeMode: true,
    freeModeMomentum: false,
    breakpoints: {
      320: { slidesPerView: 2, spaceBetween: 20 },
      480: { slidesPerView: 3, spaceBetween: 30 },
      640: { slidesPerView: 4, spaceBetween: 40 },
      992: { slidesPerView: 6, spaceBetween: 50 }
    }
  });
});